// import { Route, Routes, Switch } from "react-router-dom";
import "./App.css";
import CustomerRoutes from "./Routers/CustomerRoutes";
import AdminPannel from "./Admin/AdminPannel";
import { useSelector } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./Routers/ProtectedRoute";

const App = () => {
  const { auth } = useSelector((store) => store);
  const isTokenAvailable = localStorage.getItem("jwt");

  return (
    <Routes>
      <Route path="/*" element={<CustomerRoutes />} />
      <Route element={<ProtectedRoute />}>
        {auth && auth?.user?.role == "ADMIN" && (
          <>
            <Route path="/admin/*" element={<AdminPannel />} />
            <Route path="/" element={<Navigate to="/admin" />} />
          </>
        )}
      </Route>
    </Routes>
  );
};

export default App;
